import React from "react";

const User: React.FC = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2.25C9.3661 2.25 7.25 4.36501 7.25 7C7.25 9.634 9.366 11.75 12 11.75C14.635 11.75 16.75 9.6339 16.75 7C16.75 4.36512 14.6349 2.25 12 2.25ZM8.75 7C8.75 5.19366 10.1943 3.75 12 3.75C13.8065 3.75 15.25 5.19355 15.25 7C15.25 8.80568 13.8063 10.25 12 10.25C10.1944 10.25 8.75 8.80558 8.75 7ZM12 13.25C10.0953 13.25 8.23925 13.3976 6.83595 13.8898C6.12928 14.1377 5.48455 14.4907 5.01109 15.0049C4.52185 15.5362 4.25 16.2036 4.25 16.9892C4.25 17.7731 4.5195 18.4407 5.00579 18.9738C5.47681 19.4902 6.11909 19.8467 6.82505 20.0979C8.2267 20.5966 10.0836 20.75 12 20.75C13.9048 20.75 15.7608 20.6021 17.1641 20.1098C17.8708 19.8619 18.5154 19.5088 18.9889 18.9947C19.4781 18.4635 19.75 17.7962 19.75 17.0108C19.75 16.2269 19.4805 15.5593 18.9942 15.0262C18.5232 14.5098 17.8809 14.1533 17.175 13.9021C15.7733 13.4034 13.9164 13.25 12 13.25ZM5.75 16.9892C5.75 16.5787 5.88121 16.2744 6.11455 16.021C6.36366 15.7504 6.76103 15.5057 7.33242 15.3053C8.48524 14.9009 10.1292 14.75 12 14.75C13.8797 14.75 15.5228 14.9064 16.6721 15.3153C17.2417 15.518 17.6376 15.7647 17.886 16.037C18.119 16.2925 18.25 16.5991 18.25 17.0108C18.25 17.4209 18.1188 17.7251 17.8855 17.9786C17.6363 18.2491 17.2389 18.4939 16.6675 18.6944C15.5147 19.0988 13.8707 19.25 12 19.25C10.1203 19.25 8.47717 19.0936 7.32786 18.6847C6.75833 18.482 6.36239 18.2353 6.11405 17.963C5.88098 17.7075 5.75 17.4009 5.75 16.9892Z"
        fill="#101111"
      />
    </svg>
  );
};

export default User;
